// FAQ accordion content — questions per the Webflow tools.html design,
// answers migrated from the old site's FAQ page (content/pages/faq.md),
// with internal links updated to the new IA. Rendered as markdown.
// Translated via faq.items in the locale bundles.
export const getFaqs = t => t('faq.items', { returnObjects: true });
